import type React from "react";

export function RemoveIcon(
  props: React.SVGProps<SVGSVGElement>,
): React.ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="currentColor"
      {...props}
    >
      <title>Remove</title>
      <path d="M19 13H5v-2h14z" />
    </svg>
  );
}
